import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Divider, Typography } from '@mui/material';
import { UBItem } from './UBItemMock';
import { Link } from "react-router-dom";

export const UBWebMobile = ({title, events}) => {
  return (
      <UBItem styles={{}}>
        <Button
            component={Link}
            to={{ pathname: `/unionbank/realtime` }}
            sx={{ color: 'white', display: 'block', textTransform: 'none' }}
        >
            <Typography variant="h5" fontWeight="bold" align="center">{title}</Typography>
        </Button>

        <Divider />

        <Grid container spacing={2} p={2}>
            <Grid sm={8} md={8}></Grid>
            <Grid sm={2} md={2}>
                <Typography align="right">Web</Typography>
            </Grid>
            <Grid sm={2} md={2}>
                <Typography align="right">Mobile</Typography>
            </Grid>
                {events.map(event => {
                    return (
                        <>
                            <Grid sm={8} md={8}>
                                <Typography align="right">{event?.event_label}</Typography>
                            </Grid>
                            <Grid sm={2} md={2}>
                                <Typography align="right">{event.web}</Typography>
                            </Grid>
                            <Grid sm={2} md={2}>
                                <Typography align="right">{event.mobile}</Typography>
                            </Grid>
                        </>
                    );
                })}
        </Grid>
    </UBItem>
  );
};
